import classnames from 'classnames'
import ReactSelect, {
  components,
  Props as ReactSelectProps,
} from 'react-select'

import { useMenuPosition } from './useMenuPosition'
import { Icon } from '@/Atomic/Atoms/Icon'

import './BasicSelectStyle.scss'

export interface SelectProps extends ReactSelectProps {
  name: string
  flash?: boolean
  hasError?: boolean
}

export const Select: React.FC<SelectProps> = ({
  name,
  placeholder = 'Select',
  flash,
  hasError,
  className,
  components: callerComponents,
  ...props
}) => {
  const { menuAlign, controlRef, handleMenuOpen } = useMenuPosition()

  return (
    <div ref={controlRef}>
      <ReactSelect
        id={`react-select-${name}`}
        name={name}
        isClearable
        isSearchable
        menuPortalTarget={document.body}
        menuPosition="fixed"
        onMenuOpen={handleMenuOpen}
        className={classnames('basic-select-container', className, {
          'is-invalid': hasError,
        })}
        classNamePrefix="basic-select"
        placeholder={placeholder}
        aria-label={`select ${name}`}
        styles={{
          control: (base) => ({
            ...base,
            animation: flash ? 'flash 1s' : '',
            borderColor: hasError ? '#dc3545' : base.borderColor,
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({
            ...base,
            ...(menuAlign === 'right' && { right: 0, left: 'auto' }),
          }),
        }}
        components={{
          MultiValueRemove: (props) => (
            <components.MultiValueRemove {...props}>
              <Icon icon="cross-circle" color="strong" className="close-icon" />
            </components.MultiValueRemove>
          ),
          MenuPortal: ({ children, ...props }) => (
            <components.MenuPortal {...props}>
              <div onClick={(e) => e.stopPropagation()}>{children}</div>
            </components.MenuPortal>
          ),
          IndicatorSeparator: null,
          ...callerComponents,
        }}
        {...props}
      />
    </div>
  )
}
